import React, { Component } from 'react';
import { Grid, Button, Segment, Header, Menu, Icon } from 'semantic-ui-react'
import Mailbox from './Mailbox';
import Loading from '../Loading';
import Compose from './Compose';
import { typeList } from '../../utils/defaults';
import { getMails, getMailsBySearchedText, moveMailsFromFolder, deleteMailsFromFolder, saveMail, getMailUsers, getUnreadCount } from '../../utils/rest';
import { NotificationManager } from 'react-notifications';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
class Mails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            typeList,
            typeListCount: {
            },
            searchIndex: {
                type: "inbox"
            },
            name: "Inbox",
            sendMail: {
                msgId: 0,
                msgUsrRefIdTo: [],
                msgUsrRefIdCC: [],
                msgUsrRefIdBCC: [],
                msgSubject: "",
                msgBody: "",
                msaAttachment: []
            },
            replyOrFwdTo: {},
            mailDetails: [],
            mails: [],
            mailCheckedList: [],
            mailCheckedMoveList: [],
            replyOrFwd: false,
            loading: true,
            toggleCompose: false,
            checkAll: false,
            title: "",
            replyCrpId: 0,
            userList: [],
            searchValue: ""
        };
        this.searchBoxRef = React.createRef();
    }

    componentDidMount() {
        this.props.addItem("helpFile", "messaging_inbox.md");
        this.getMails(this.state.searchIndex, false);
        if (this.state.userList.length === 0) {
            this.getUsersList();
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.getUsersList();
        }
    }

    getUsersList() {
        if (this.state.replyCrpId !== this.props.items.currentCorporate) {
            getMailUsers(this.state.replyCrpId ? this.state.replyCrpId : this.props.items.currentCorporate).then((response) => {
                if (response !== null && response instanceof Array) {
                    this.setState({
                        userList: response.map((i) => {
                            return {
                                text: i.usrFirstName + ' ' + i.usrLastName + ' <' + i.usrUserName + '>',
                                value: i.usrId,
                                key: i.usrId
                            }
                        })
                    })
                }
            })
        }
    }

    getMails = (params, pointSearchBox) => {
        this.setState({
            loading: true
        }, () => {
            getUnreadCount().then((typeListCount) => {
                if (typeListCount !== null && typeListCount instanceof Object) {
                    this.setState({ typeListCount });
                    this.props.addItem("notification", typeListCount);
                }
            }).then(() => {
                getMails(params).then((response) => {

                    if (response != null && (response instanceof Array)) {
                        this.setState({
                            mails: response,
                            loading: false,
                            mailCheckedList: [],
                            mailCheckedMoveList: [],
                            checkAll: false,
                            searchValue: ""
                        });
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                    if(pointSearchBox){
                        this.searchBoxRef.current.focus()
                    }
                })
            })

        })
    }
    showEmailContent = (value, mail, mailId, read) => {
        let sendMail = this.state.sendMail;
        let mails = this.state.mails;
        if (this.state.searchIndex.type === "draft") {
            if (mail.length > 0) {
                sendMail.msgId = mail[0].msgId;
                sendMail.msgBody = mail[0].msgBody;
                sendMail.msgSubject = mail[0].msgSubject;
                sendMail.msgUsrRefIdBCC = mail[0].msgUsrRefIdBCC;
                sendMail.msgUsrRefIdCC = mail[0].msgUsrRefIdCC;
                sendMail.msgUsrRefIdTo = mail[0].msgUsrRefIdTo;
                sendMail.msaAttachment = mail[0].msaAttachment;
            }
        }
        this.setState((prevProps) => {
            return {
                toggleCompose: value,
                mailDetails: mail,
                mailId,
                sendMail,
                mails: mails.filter((m) => {
                    if (m.msrRecId === mailId) {
                        m.msrFlag = 'R'
                    }
                    return true;
                }),
                typeListCount: {
                    ...this.state.typeListCount,
                    [this.state.searchIndex.type]: (read && prevProps.typeListCount[this.state.searchIndex.type] ? prevProps.typeListCount[this.state.searchIndex.type] - 1 : prevProps.typeListCount[this.state.searchIndex.type])
                },
                mailCheckedMoveList: [mailId]
            }
        });
    }

    close = () => {
        let closedFromReply = this.state.replyOrFwd;
        let replyCrpId = this.state.replyCrpId;
        this.setState({
            toggleCompose: false,
            mailCheckedMoveList: [],
            replyOrFwd: false,
            loading: false,
            replyCrpId: 0,
            sendMail: {
                msgId: 0,
                msgUsrRefIdTo: [],
                msgUsrRefIdCC: [],
                msgUsrRefIdBCC: [],
                msgSubject: "",
                msgBody: "",
                msaAttachment: []
            },
            userList: this.newUserList("msgUsrRefIdTo", []),
        }, () => {
            if (closedFromReply && replyCrpId !== this.props.items.currentCorporate) {
                this.getUsersList();
            }
        });

    }

    loadMails = (type, text, value) => {
        this.setState({
            name: text,
            searchIndex: {
                ...this.state.searchIndex,
                type: type
            },
        }, () => { this.getMails(this.state.searchIndex, false); });
    }

    checkedItemsForDelete = (msrRecId, addedOrRemove, mailCheckedList) => {

        this.setState({
            ...this.state,
            mailCheckedList
        }, () => {
            let mailCheckedMoveList = this.state.mailCheckedMoveList;
            if (addedOrRemove) {
                mailCheckedMoveList.push(msrRecId);
                this.setState({
                    ...this.state,
                    mailCheckedMoveList
                })
            } else {
                var rIndex = mailCheckedMoveList.indexOf(msrRecId);
                if (rIndex !== -1) {
                    mailCheckedMoveList.splice(rIndex, 1);
                    this.setState({
                        ...this.state,
                        mailCheckedMoveList
                    })
                }
            }
        })
    }

    setCheckAll = () => {
        let checkAll = !this.state.checkAll;
        let mailCheckedList = [];
        let mailCheckedMoveList = [];
        this.state.mails.forEach(function (item, index) {
            mailCheckedList[index] = checkAll;
            if (checkAll) {
                mailCheckedMoveList.push(item.msrRecId)
            }
        });
        this.setState({
            mailCheckedList,
            mailCheckedMoveList,
            checkAll: checkAll
        });
    }

    removeFromList = () => {
        let mails = this.state.mails;
        this.setState({
            mails: mails.filter((item, index) => {
                return this.state.mailCheckedMoveList.indexOf(item.msrRecId) === -1
            }),
            mailCheckedList: [],
            mailCheckedMoveList: [],
            checkAll: false
        });
    }

    handleMove = (folder) => {
        if (this.state.mailCheckedMoveList.length > 0) {
            this.setState({
                loading: true
            }, () => {

                moveMailsFromFolder(this.state.mailCheckedMoveList, { folder: folder }).then((response) => {
                    if (response != null) {
                        this.removeFromList();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            })
        }
    }

    handleDelete = () => {
        if (this.state.mailCheckedMoveList.length > 0) {
            this.setState({
                loading: true
            }, () => {

                if (this.state.searchIndex.type === "trash") {
                    deleteMailsFromFolder(this.state.mailCheckedMoveList, { folder: "trash" }).then((response) => {
                        if (response != null) {
                            this.removeFromList();
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        });
                    })
                } else {
                    moveMailsFromFolder(this.state.mailCheckedMoveList, { folder: "trash" }).then((response) => {
                        if (response != null) {
                            this.removeFromList();
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        });
                    })
                }
            })
        }
    }

    replyOrFwd = (mode) => {
        let replyDetails = this.state.mailDetails[0];
        let msgUsrRefIdTo = [];
        let msgUsrRefIdCC = [];
        let msgSubject = replyDetails.msgSubject;;
        if (mode === "Reply") {
            msgUsrRefIdTo = [replyDetails.msgUsrRefIdFrom];
        } else if (mode === "Reply All") {
            msgUsrRefIdTo = Array.from(new Set(replyDetails.msgUsrRefIdTo.concat(replyDetails.msgUsrRefIdFrom)))
            msgUsrRefIdCC = (replyDetails.msgUsrRefIdCC !== null) ? replyDetails.msgUsrRefIdCC.filter((i) => {
                return msgUsrRefIdTo.indexOf(i) === -1;
            }) : msgUsrRefIdCC;
        }
        this.setState({
            title: mode,
            userList: this.newUserList("msgUsrRefIdTo", msgUsrRefIdTo.concat(msgUsrRefIdCC)),
            sendMail: {
                ...this.state.sendMail,
                msgUsrRefIdTo,
                msgUsrRefIdCC,
                msgSubject
            },
            replyOrFwd: true,
            replyCrpId: replyDetails.msgCrpRefId
        }, () => this.getUsersList())
    }

    onContentChange = (evt) => {
        let newContent = evt.editor.getData()
        this.setState({
            sendMail: {
                ...this.state.sendMail,
                msgBody: newContent
            }
        });
    }

    deleteAttachement = (id) => {
        let msaAttachment = this.state.sendMail.msaAttachment;
        msaAttachment = msaAttachment.filter((attachment) => {
            return attachment.id !== id
        })
        this.setState({
            sendMail: {
                ...this.state.sendMail,
                msaAttachment
            }
        })
    }

    addAttachement = (files) => {
        let prevAttachment = this.state.sendMail.msaAttachment !== null ? this.state.sendMail.msaAttachment : [];
        let msaAttachment = prevAttachment.concat(files);
        this.setState({
            sendMail: {
                ...this.state.sendMail,
                msaAttachment
            }
        })
    }

    newUserList = (name, value) => {
        let userList = this.state.userList;
        let findAt = ["msgUsrRefIdTo", "msgUsrRefIdCC", "msgUsrRefIdBCC"].indexOf(name);
        if (findAt >= 0) {
            let selectedItems = Array.from(new Set(value.concat(
                findAt !== 0 ? this.state.sendMail.msgUsrRefIdTo : [],
                findAt !== 1 ? this.state.sendMail.msgUsrRefIdCC : [],
                findAt !== 2 ? this.state.sendMail.msgUsrRefIdBCC : [])));
            userList = userList.filter((u) => {
                if (selectedItems.indexOf(u.value) >= 0) {
                    u.disabled = true;
                } else {
                    u.disabled = false;
                }
                return true;
            })
        }
        return userList;
    }

    handleChange = (e, evt) => {
        this.setState({
            userList: this.newUserList(evt.name, evt.value),
            sendMail: {
                ...this.state.sendMail,
                [evt.name]: evt.value
            }
        });
    }

    checkEmpty = (searchIndex, except) => {
        let r = false;
        for (let search in searchIndex) {
            if (searchIndex[search].length > 0 && except.indexOf(search) === -1) {
                r = true;
                break;
            }
        }
        return r;
    }

    handleSubmit = (params) => {

        if (this.checkEmpty(this.state.sendMail, [])) {

            this.setState({
                loading: true
            }, () => {
                let replyDetails = this.state.mailDetails.length > 0 ? this.state.mailDetails[0] : [];
                let data = Object.assign(this.state.sendMail,
                    {
                        msgThread: (replyDetails && replyDetails.msgThread) ? replyDetails.msgThread : 0,
                        msgId: (replyDetails && replyDetails.msgId) ? replyDetails.msgId : 0,
                        msgCrpRefId: replyDetails && replyDetails.msgCrpRefId > 0 ? replyDetails.msgCrpRefId : this.props.items.currentCorporate
                    });
                let method = this.state.searchIndex.type === "draft" ? "PUT" : "POST";
                let msgNotification = this.state.searchIndex.type === "draft" ? "Saved" : "Send";
                saveMail(method, data, params).then(response => {
                    if (response !== null) {

                        if(this.state.searchValue.length > 0){
                            this.getSearchedMail();
                        }else{
                            this.getMails({ type: this.state.searchIndex.type }, false);
                        }
                        
                        NotificationManager.success('Success', msgNotification + ' successfully.');
                        this.close();
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            })
        }

    }

    handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            
           this.getSearchedMail();
        }
    }

    getSearchedMail = () => {
        if(this.state.searchValue.length > 0) {
            this.setState({
                loading: true
            }, () => {
                
                getMailsBySearchedText(this.state.searchIndex, this.state.searchValue).then((response) => {
    
                    if (response != null) {
                        this.setState({
                            mails: response.message,
                            loading: false,
                            mailCheckedList: [],
                            mailCheckedMoveList: [],
                            checkAll: false,
                            typeListCount: response.unread == null ? this.state.typeListCount : response.unread
                        });
                    }

                    this.searchBoxRef.current.focus()
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
           
            })
        }else{
            this.getMails(this.state.searchIndex, true)
        }
    }

    handleSearchKeyChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    render() {
        const typeList = (
            this.state.typeList.map((item, index) => (
                <a className={"item " + ((this.state.searchIndex.type === item.key) ? "active" : "")} key={index} onClick={() => this.loadMails(item.key, item.value)}>
                    <Icon className={((this.state.searchIndex.type === item.key) ? "blue " : "") + item.icon} /> {item.value + (this.state.typeListCount[item.key] > 0 ? " (" + this.state.typeListCount[item.key] + ")" : "")}
                </a>
            ))
        )
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Messaging" child={[{ name: this.state.name, url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Column width={3}>
                        <Segment.Group>
                            <Segment>
                                <Header as='h5'>Email</Header>
                            </Segment>
                            <Segment>
                                <Menu fluid vertical>
                                    <Button style={{ borderRadius: "0" }} size='small' fluid onClick={() => this.showEmailContent(true, [], 0, false)}>
                                        <Icon className='left floated edit' />
                                        {this.props.t("compose")}
                                    </Button>
                                    {typeList}
                                </Menu>
                            </Segment>
                        </Segment.Group>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Mailbox
                            {...this.props}
                            setCheckAll={this.setCheckAll}
                            checkAll={this.state.checkAll}
                            refresh={() => { this.getMails(this.state.searchIndex) }}
                            checkedItemsForDelete={this.checkedItemsForDelete}
                            mailCheckedList={this.state.mailCheckedList}
                            mails={this.state.mails}
                            type={this.state.searchIndex.type}
                            name={this.state.name}
                            removeFromList={this.removeFromList}
                            showEmailContent={this.showEmailContent}
                            handleDelete={this.handleDelete}
                            handleMove={this.handleMove}
                            handleSearchKeyDown={this.handleSearchKeyDown}
                            handleSearchKeyChange={this.handleSearchKeyChange}
                            searchValue={this.state.searchValue}
                            searchBoxRef={this.searchBoxRef}
                        />
                    </Grid.Column>
                </Grid>
                <Compose
                    toggleCompose={this.state.toggleCompose}
                    close={this.close}
                    mailDetails={this.state.mailDetails}
                    read={this.state.mailDetails.length === 0 || this.state.replyOrFwd ? false : true}
                    mailId={this.state.mailId}
                    type={this.state.searchIndex.type}
                    removeFromList={this.removeFromList}
                    checkedItemsForDelete={this.checkedItemsForDelete}
                    replyOrFwd={this.replyOrFwd}
                    sendMail={this.state.sendMail}
                    replyOrFwdContent={this.state.replyOrFwd}
                    handleChange={this.handleChange}
                    handleSubmit={this.handleSubmit}
                    onContentChange={this.onContentChange}
                    title={this.state.title}
                    userList={this.state.userList}
                    addAttachement={this.addAttachement}
                    deleteAttachment={this.deleteAttachement}
                    {...this.props}
                />
            </div>
        );
    }
}
export default Mails;


// WEBPACK FOOTER //
// ./src/app/ui/mails/Mails.js